import { createSlice } from "@reduxjs/toolkit";
import {DayWiseRecord, DayWiseVisitStatusRecord, MarketScanFormData, MarketScanFormPayload} from "../Constants/type";
import {
  GET_MARKET_SCAN_RECORDS,
  CREATE_MARKET_SCAN_RECORD,
  GET_MARKET_SCAN_RECORD_ID,
  UPDATE_MARKET_SCAN_RECORD_ID,
} from "../Constants/urls";

import { displayToast } from "./ToastSlice";

const marketScanRecord: MarketScanFormData = {
  id:'',
  visited_at: '',
  address: '',
  shop_name: '',
  shop_size: '',
  landmarks: [],
  area_description: '',
  road_description: '',
  product_categories: [],
  visit_status: [] as DayWiseVisitStatusRecord[],
  decision_makers: 0,
  influencers: 0,
  conversion_chances: [] as DayWiseRecord[],
  openness: [] as DayWiseRecord[],
  ownership: '',
  owner_name: '',
  contact_number: '',
  notes: [] as DayWiseRecord[],
  image_link: '',
};

const initialState = {
  marketScanRecords: [] as MarketScanFormData[],  
  singleMarketScanRecord: marketScanRecord,  
  fetching:false,
};

export const slice = createSlice({
  name: "marketScan",
  initialState,
  reducers: {
    //this will append a new record into the existing record
    addMarketScanRecord: (state, action) => {
      state.marketScanRecords = [...state.marketScanRecords, action.payload]
    },
    //this will replace entire list of records with new records
    setMarketScanRecords: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.marketScanRecords = [...action.payload];
      } else {
        state.marketScanRecords = [];
      }
    },
    setSingleMarketScanRecord: (state, action) => {
      state.singleMarketScanRecord = action.payload;
    },
    setFetching: (state, action) => {
      state.fetching = action.payload;
    },
  },
});


export const { addMarketScanRecord,setMarketScanRecords,setSingleMarketScanRecord, setFetching } = slice.actions;


export const createMarketScanRecord = (record:MarketScanFormPayload,cb: () => void) => async (dispatch: any) => {
  dispatch(setFetching(true));
  let res;
  try {
    res = await window.fetch(CREATE_MARKET_SCAN_RECORD, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(record),
    });
    const data = await res.json();
    record.market_scan_record.id=data.id
    if (res.status === 200) {
      dispatch(addMarketScanRecord(record.market_scan_record))
      if (cb)  cb();
      dispatch(displayToast("Inserted the record"))
    } else { dispatch(displayToast(data.msg));
    }
  } catch (err) {
    console.log(err);
  }
  dispatch(setFetching(false));
};


export const getMarketScanRecordById = (id:string,cb: () => void) => async (dispatch:any) => {
  dispatch(setFetching(true));
  try {
    console.log("Getting data");
    const response = await window.fetch(`${GET_MARKET_SCAN_RECORD_ID}/${id}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    const data = await response.json();
    if (response.status === 200) {
      dispatch(setSingleMarketScanRecord(data)); 
      if (cb) cb();
      dispatch(displayToast("Fetched market scan record"));
    } else {
      dispatch(displayToast(data.msg));
    }
  } catch (err) {
    console.error(err);
  }
  dispatch(setFetching(false));
};

export const updateMarketScanRecordById = (record:MarketScanFormPayload,id:string,cb: () => void) => async (dispatch:any) => {
  dispatch(setFetching(true));
  try {
    console.log("Updating data...");
    const p=JSON.stringify(record)
    console.log(id);
    const response = await window.fetch(`${UPDATE_MARKET_SCAN_RECORD_ID}/${id}`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: p,
    });
    const data = await response.json();
    console.log(data);
    if (response.status === 200) {
      if (cb) cb();
      dispatch(displayToast("Updated market scan record"));
    } else {
      dispatch(displayToast(data.msg));
    }
  } catch (err) {
    console.error("Hel",err);
  }
  dispatch(setFetching(false));
};


export const fetchMarketScanRecords = () => async (dispatch:any) => {
  dispatch(setFetching(true));
  console.log("Fechingggg");
  try {
    const response = await window.fetch(GET_MARKET_SCAN_RECORDS, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    const data = await response.json();
    if (response.status === 200) {
      dispatch(setMarketScanRecords(data)); 
      dispatch(displayToast("Fetched market scan records"));
    } else {
      dispatch(displayToast(data.msg));
    }
  } catch (err) {
    console.error(err);
  }
  dispatch(setFetching(false));
};



export const selectMarketScanRecords = (state: any) => state.marketScan.marketScanRecords;

export const selectMarketScanRecord = (state: any) => state.marketScan.singleMarketScanRecord;

export default slice.reducer;
